import { Loading, Message, MessageBox } from 'element-ui'
let _gLoadingInstance = null
const showLoading = (fullscreen = true) => {
  return Loading.service({
    fullscreen
  })
}

const hideLoading = (loadingInstance) => {
  loadingInstance = loadingInstance || _gLoadingInstance
  loadingInstance.close()
}

const showGlobalLoading = () => {
  if (!_gLoadingInstance) {
    _gLoadingInstance = showLoading()
  }
}

const hideGlobalLoading = () => {
  if (_gLoadingInstance) {
    hideLoading(_gLoadingInstance)
    _gLoadingInstance = null
  }
}

const toastSuccess = (msg) => {
  toast(msg, 'success')
}

const toastError = (msg) => {
  toast(msg, 'error')
}

const toastInfo = (msg) => {
  toast(msg, 'info')
}

const toastWarning = msg => {
  toast(msg, 'warning')
}

const toast = (msg, type) => {
  Message({
    message: msg,
    type,
    customClass: 'toast_custom_class'
  })
}

const showConfirm = (message, title = '提示') => {
  return new Promise((resolve, reject) => {
    MessageBox.confirm(message, title, {
      customClass: 'my_class',
      lockScroll: true,
      callback: (action, instance) => {
        if (action === 'confirm') {
          resolve(instance)
        } else {
          reject(instance)
        }
      }
    })
  })
}

export {
  showGlobalLoading,
  hideGlobalLoading,
  showLoading,
  hideLoading,
  toastSuccess,
  toastError,
  toastInfo,
  toastWarning,
  showConfirm
}



// WEBPACK FOOTER //
// ./src/common/utils/ui.js